export default () => ({
  passthrough: '',
  token: localStorage.getItem('token'),
  loggedUser: {
    username: null,
    role: null
  },
  userProfile: JSON.parse(localStorage.getItem('userProfile')),
  primaryRole: JSON.parse(localStorage.getItem('role')),
  roles: JSON.parse(localStorage.getItem('roles')),
  solutions: [
    {
      id: 1,
      name: 'UK/Europe',
      value: 1,
      type: 'ServiceRequest'
    },
    {
      id: 2,
      name: 'Glass US/Canada',
      value: 2,
      type: 'ServiceRequestGlass'
    },
    {
      id: 3,
      name: 'Calibration US/Canada',
      value: 4,
      type: 'ServiceRequestCalibration'
    },
    {
      id: 4,
      name: 'ProTech',
      value: 5,
      type: 'ServiceRequestProTech'
    }
  ],
  channelType: localStorage.getItem('channelType') || 'ServiceRequest',
  solution: localStorage.getItem('solution') || 1
})



// WEBPACK FOOTER //
// ./src/store/modules/auth/state.js